export default "__VITE_ASSET__f4E9uNA6__"